import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class ReportSubscriptionsProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'report-subscriptions'
}
